export default function isActiveMark(editor, markType) {
  return editor.value.activeMarks.some(function (mark) {
    return mark.type === markType;
  });
}